/**
 * Data layer for `flat-fee-percentage-fixed-commission-payouts-per-influencer`. Thin typed fetch wrappers over /api/v1/flat-fee-percentage-fixed-commission-payouts-per-influencer.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface FlatFeePercentageFixedCommissionPayoutsPerInfluencerRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListFlatFeePercentageFixedCommissionPayoutsPerInfluencerResponse {
	count: number;
	items: FlatFeePercentageFixedCommissionPayoutsPerInfluencerRow[];
}

export interface CreateFlatFeePercentageFixedCommissionPayoutsPerInfluencerBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/flat-fee-percentage-fixed-commission-payouts-per-influencer";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListFlatFeePercentageFixedCommissionPayoutsPerInfluencerResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListFlatFeePercentageFixedCommissionPayoutsPerInfluencerResponse>(res);
}

export async function create(body: CreateFlatFeePercentageFixedCommissionPayoutsPerInfluencerBody): Promise<FlatFeePercentageFixedCommissionPayoutsPerInfluencerRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<FlatFeePercentageFixedCommissionPayoutsPerInfluencerRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const flatFeePercentageFixedCommissionPayoutsPerInfluencerQueryKeys = {
	all: ["flat-fee-percentage-fixed-commission-payouts-per-influencer"] as const,
	list: () => [...flatFeePercentageFixedCommissionPayoutsPerInfluencerQueryKeys.all] as const,
	detail: (id: string) => [...flatFeePercentageFixedCommissionPayoutsPerInfluencerQueryKeys.all, id] as const,
};
